import styled from "styled-components";

function ProgramItem({thumbnailImg, title, classData, optionList}){
    const renderOption = () => {
        if(optionList && optionList.length){
            return optionList.map((item, index) => {
                return <Li key={item.id}>{`${item.name}`}</Li>
            })
        }
        return null;
    }

    return(
       <Container>
         <ThumbnailImg src={thumbnailImg} alt="thumbnail_img"/>
            <Content>
                <Title>{title}</Title>
                <Ul>
                    <Li>{`${classData.name}`}</Li>
                    {renderOption()}
                </Ul>
            </Content>
       </Container>
    )
}

const Container = styled.div`
    display: flex;
    align-items: center;
    gap: 20px;
    padding-left: 30px;
    padding-right: 30px;
    @media (max-width: 600px) {
        flex-direction: column;
        align-items: center;
    }
`

const ThumbnailImg = styled.img`
    width: 200px;
    height: 150px;
    @media (max-width: 600px) {
        width: 100%;
        height: auto;
    }
`

const Content = styled.div`
    display: flex;
    flex-direction: column;
    padding-top: 10px;
    padding-bottom: 10px;
    height: 100%;
`

const Title = styled.div`
    font-size: 18px;
    font-weight: 600;
`

const Ul = styled.ul`

`
const Li = styled.li`
    font-size: 16px;
`
export default ProgramItem;